import styled, { css } from 'styled-components';

import { Flex } from '@/components/Flex';

import { Col } from '../Col';
import { Typography } from '../Typography';

export const Container = styled(Flex)`
  align-items: flex-start;
  flex-direction: column;
  grid-column: span 12;

  ${({ theme }) => css`
    row-gap: ${theme.spacing(4)};
  `}
`;

export const Text = styled(Typography)`
  a {
    color: ${({ theme }) => theme.colors.primaryDark};
  }
`;

export const TermsFormCol = styled(Col)<{ $disabled?: boolean }>`
  ${({ $disabled }) => css`
    ${$disabled &&
    css`
      opacity: 0.4;
      pointer-events: none;
    `}
  `}
`;
